import { render, staticRenderFns } from "./ChooseRelatedProgramModal.vue?vue&type=template&id=ba75f1aa&scoped=true&"
import script from "./ChooseRelatedProgramModal.vue?vue&type=script&lang=js&"
export * from "./ChooseRelatedProgramModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRelatedProgramModal.vue?vue&type=style&index=0&id=ba75f1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba75f1aa",
  null
  
)

export default component.exports